
import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { UtilsService } from 'app/core/util/view-file.component';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ContentNavigationService } from 'app/entities/cbic-content-mst/view-content/services/content-navigation.service';
import { CbicMenuMstService } from 'app/entities/cbic-menu-mst/service/cbic-menu-mst.service';
import { SessionStorageService } from 'ngx-webstorage'; 


@Component({
  selector: 'cbic-scam-alert',
  templateUrl: './scam-alert.component.html',
  styleUrls: ['./scam-alert.component.scss'],
})
export class ScamComponent implements OnInit {
    usedLanguage: any;
    isBreadcrumb? = true;
    cbicContentMst?: ICbicContentMst | null;
    color: any;
    // contentId: any;
    pressdataflag: any = 'New';
    newsMediaPressData: any;
    newsMediaPressDataNotFound = false;
    newsMediaDataNotfound: any;
    PdfDataList: any;
    firstPage: any;
    lastPage: any;
    nextPage: any;
    nextSize: any;
    prevPage: any;
    prevSize: any;
    page = 1;
    Pageing = 0;
    pageSize: any = 10;
    count: any = 0;
    tableSize = 10;
    tableSizes = [10, 15, 20, 25, 50, 100, 200]
    public topNavigationService: ContentNavigationService;
  
  scamContent: any;
    flag: any;
    activetedRoute: any;
    contentType: any;
 
  constructor(private sessionStorageService: SessionStorageService,
    private contentMstService: CbicContentMstService, 
    public menuService: CbicMenuMstService,
    private changeLnService: ChangeLanguageService, 
    private utils: UtilsService,private activatedRoute: ActivatedRoute) {

        this.topNavigationService = new ContentNavigationService(menuService);
     }

//   isDataAvailable(){
//     let dataAvailable = true;
//     dataAvailable &&= this.taxLegislationList !=null && this.taxLegislationList.length!==0;
//     if(dataAvailable){
//       dataAvailable &&= this.onlineServiceList !=null && this.onlineServiceList.length!==0;  
//     }
//     if(dataAvailable){
//       dataAvailable &&= this.manualServiceList !=null && this.manualServiceList.length!==0;  
//     }
//     if(dataAvailable){
//       dataAvailable &&= this.gstRateServiceList !=null && this.gstRateServiceList.length!==0;  
//     }
//     if(dataAvailable){
//       dataAvailable &&= this.miscellaneousServiceList !=null && this.miscellaneousServiceList.length!==0;  
//     }
//     if(dataAvailable){
//       dataAvailable &&= this.gstUpdatesList !=null && this.gstUpdatesList.length!==0;  
//     }
//     return dataAvailable;
//    };

  ngOnInit(): void {
    //  GSTComponent.constructor();
    this.usedLanguage = this.changeLnService.getLanguage();
    this.activatedRoute.data.subscribe(({ contentTypeCode }) => {
        this.contentType = contentTypeCode;
        this.getScamContent();
      });



    this.isDataAvailable() 
   
  console.log(this.scamContent);
    this.color = this.sessionStorageService.retrieve('colr');
  }

  getScamContent(): void {
    this.contentMstService.getContentData('scam-alert-content').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        console.log(res);
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
            
          } else {
            this.flag = 'En';
            
          }
          this.scamContent = res.body;
        }
      }
    )
  }


  isDataAvailable() {
    let dataAvailable = true;
    dataAvailable &&= this.scamContent != null && this.scamContent.length !== 0;
    if (dataAvailable === false) {
      this.scamContent = 'No data available.';
    }
    return dataAvailable;
  };


  getnewsmediaData(contentTypeId: any, Pageing: any, pageSize: any, flag: any): void {
    this.contentMstService.getNewsAndMediadocMstData(contentTypeId, Pageing, pageSize, flag)
      .subscribe(
        (res: HttpResponse<any>) => {
          this.newsMediaPressData = res
          if (this.newsMediaPressData.length === 0) {
            this.newsMediaPressDataNotFound = true
          } else {
            this.newsMediaPressDataNotFound = false;
          }
        });
  }

  getContentCount(contentId: any, flag: any): void {
    this.contentMstService.getContentCountByParentId(contentId, flag).subscribe((res: HttpResponse<number>) => {
      if (res) {
        this.count = res.body;
        console.log(this.count);
      }
    });
  }

  ViewPdf(filePath: any) {
    this.utils.viewOpenning(filePath);
  }

  onTableDataChange(event: any) {
    // const request: any = {};
    this.Pageing = event - 1;
    this.pageSize = this.tableSize;
    this.getnewsmediaData(this.contentId, this.Pageing, this.pageSize, this.pressdataflag);
  }
    contentId(contentId: any, Pageing: number, pageSize: any, pressdataflag: any) {
        throw new Error('Method not implemented.');
    }

  ontableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    const request: any = {};
    this.Pageing = this.page - 1;
    // request['size'] = event.pageSize.toString();
    this.getnewsmediaData(this.contentId, this.Pageing, this.tableSize, this.pressdataflag);
  }

  pressReleaseClick(event: MatTabChangeEvent) {
    if (event.index === 1) {
      this.pressdataflag = 'Old'
      this.Pageing = 0;
      this.pageSize = this.tableSize;
    }
    else {
      this.pressdataflag = 'New'
      this.Pageing = 0;
      this.pageSize = this.tableSize;
    }
    this.page = 1;
    this.getnewsmediaData(event.tab.textLabel, this.Pageing, this.pageSize, this.pressdataflag)
    this.getContentCount(this.contentId, this.pressdataflag);
  }

}




